export const LOCAL_STORAGE_KEYS = {
    BZ_SPEAKERS_TAB_ID: 'BZ_SPEAKERS_TAB_ID'
};

class LocalStorageApiClass {
    getItem(key) {
        return key ? window.localStorage.getItem(key): null;
    }

    setItem(key, value = '') {
        if (key){
            window.localStorage.setItem(key, value);
        }
    }

    removeItem(key) {
        if (key){
            window.localStorage.removeItem(key);
        }

    }
}

export const LocalStorageApi = new LocalStorageApiClass();
